import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

const PriceAlertsCounter = () => {
    const { priceAlerts = {}, isGetAllRequested = false } = useSelector((state) => (state.account.priceAlerts || {}), shallowEqual);
    const { MainColor: { ActiveText } = { ActiveText: '#FF5722' } } = useSelector((state) => (state.brand?.theme || {}), shallowEqual);
    
    // Count only active alerts
    const priceAlertsQuantity = Object.values(priceAlerts).filter(alert => alert).length;
    
    if (!isGetAllRequested) {
        return null;
    }

    return (
        <div className='quantity-mark large' style={{ backgroundColor: ActiveText }}>
            {priceAlertsQuantity}
        </div>
    );
};

export default PriceAlertsCounter;
